/**
 * An error that should be reported to sentry or other telemetry
 */
export class ReportError extends Error {
    constructor(_response) {
        var _a;
        let statusCode = '';
        if (_response.status !== undefined) {
            if (_response.status === -1) {
                statusCode = `: ${_response.status} (${_response.response.status})`;
            }
            else {
                statusCode = `: ${_response.status}`;
            }
        }
        else if (_response.response.status !== 0) {
            statusCode = `: ${_response.status} (unexpected)`;
        }
        let operation = 'unknown operation';
        if (((_a = _response.request) === null || _a === void 0 ? void 0 : _a.operationId) !== undefined) {
            operation = _response.request.operationId;
        }
        const message = `${operation}${statusCode}`;
        super(message);
        this._response = _response;
        this.name = 'APIError';
    }
    get response() {
        return this._response;
    }
}
/**
 * An error for issues that shouldn't be reported to sentry, but when throwing an exception may still be desirable.
 *
 * Example usage: useQuery and useMutation will still handle this as regular errors, so isError can be used.
 */
export class IgnoredError extends Error {
    constructor(_response) {
        super('Ignored error (this should not appear)');
        this._response = _response;
    }
    get response() {
        return this._response;
    }
}
//# sourceMappingURL=errors.js.map